// ===============================================================================
// Fetch product to cart Drawer
$(document).ready(function() {
  jQuery('[data-product-form]').submit(function(e){
    e.preventDefault();
    
    var data = $(this).serialize();
    var qty = 1;
    $.ajax({
      type: 'POST',
      url: '/cart/add',
      data: data,
      dataType: 'html',
      success: function(response) {
        // Store any additional items here
        let additionalItems = [];  
        let quantity_added = Number($('#quantity').val());
        if(quantity_added <= 0) {
          quantity_added = 1;
        }
              
        // Check if Rug Underlay is added
        let addonChecked = $('#addon-toggle__switch');
        if (addonChecked.length && addonChecked.is(':checked')) {
          let addonVariantId = $('.addon-variants_wrapper').val();
          if (addonVariantId) {
            let addonData = {
              id: parseInt(addonVariantId),
              quantity: 1,              
            };
            additionalItems.push(addonData);
          }
        }
        
        // Check if Upsells are Added
        console.log('responseAdded', data);
        $('.addon-upsell__switch').each((index, element) => {          
          if(element.checked) {            
            additionalItems.push({
              id: parseInt(element.value),
              quantity: quantity_added,              
            });
          }
        });

        // If an extra product is added to cart, make a new POST 
        if(additionalItems.length){            
          $.ajax({
              type: 'POST',
              url: '/cart/add',
              data: JSON.stringify({ items: additionalItems }),
              contentType: 'application/json',
              dataType: 'html',
              success: function(addonResponse) {
                updateCartDrawer(addonResponse);
              },
              error: function() {
                updateCartDrawer(response);
              }
            });
        } else {
          updateCartDrawer(response);
        }
        
      },
      error: function() {
        console.log('Error adding product to cart.');
      }
    });
  });
  function updateCartDrawer(response = null) {
    if (response) {
      $('.cart__drawer').html($(response).find('.cart__drawer').html()).addClass('show-cart__drawer');
      $('.header-cart-btn').html($(response).find('.header-cart-btn').html());
    }
    $('.cart__drawer-form').removeClass('hidden');
    $('#EmptyCart').addClass('hidden');
    $('.cart__drawer').addClass('show-cart__drawer');
    $('body').addClass('cv--show-cart__drawer');
    $('.cross').click(function() {
      $('.cart__drawer').removeClass('show-cart__drawer');
    });
  }
});

// ===============================================================================

$(document).ready(function() {

  // Cart Drawer Open On Click Cart Icon
  $(document).on("click",".header-cart-btn.cart-toggle,.mobile-icons .cart-toggle", function(e) {
     e.preventDefault();
     $('.cart__drawer').toggleClass('show-cart__drawer');
     $('body').toggleClass('cv--show-cart__drawer');
  });
  
  // Cart Drawer Close On Click cross Icon
  $(document).on("click",".cross",function() {
    $('.cart__drawer').removeClass('show-cart__drawer');
    $('body').removeClass('cv--show-cart__drawer');
  });
  
  // Close Cart Drawer click anywhere
  $(document).mouseup(function(e){
     var container = $(".cart__drawer-section");
     if (!container.is(e.target) && container.has(e.target).length === 0){
       container.show();
       $('.cart__drawer').removeClass('show-cart__drawer');
       $('body').removeClass('cv--show-cart__drawer');
     }
  });
});

// ===============================================================================

$(document).ready(function() {
  // Remove Item from Cart
  $(document).on("click",".cart__remove",function(e) {
    e.preventDefault();
    var itemUrl = $(this).attr('href');
    $.ajax({
      url: itemUrl,
      type:'GET',
      dataType: 'html',
      success: function(response){
        var cartCount = parseInt($(response).find('.header-cart-btn .cart-count').text());
        if(cartCount == 0){
          $('.cart__drawer-form').addClass('hidden');
          $('#EmptyCart').removeClass('hidden');
        }
        $('.cart__drawer').html($(response).find('.cart__drawer').html());
        $('.header-cart-btn').html($(response).find('.header-cart-btn').html());
      }
    });
  });
});

// ===============================================================================

// Change In Quantity Selector
$(document).ready(function() {

  $(document).on("click",".cart__drawer .plus",function() {
    $(this).prev().val(+$(this).prev().val() + 1);
    var data =  $(this).data('line');
    var quantity = $(this).prev().val();
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        $('.cart__drawer').html($(response).filter('.cart__drawer').html());
      }
    });

  });

  $(document).on("click",".cart__drawer .minus",function() {
    if ($(this).next().val() > 0) {
      $(this).next().val(+$(this).next().val() - 1);
      var data =  $(this).data('line');
      var quantity = $(this).next().val();
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'html',
        success: function(response){
          $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
          $('.cart__drawer').html($(response).filter('.cart__drawer').html());
        }
      });
    }
  });
});